module.exports = __webpack_public_path__ + "img/9788925539782.b18daba2.jpg";